import { render, staticRenderFns } from "./IconHeart.vue?vue&type=template&id=d2bad5c4&functional=true"
import script from "./IconHeart.vue?vue&type=script&lang=js"
export * from "./IconHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports